const hostname = window && window.location && window.location.hostname

let API_HOST = "https://qa.api.noahtemplet.dev/api";

export { API_HOST }